/**
 * Tenant identifiers used across the application.
 * These values must match the folder names in /tenants directory.
 *
 * NOTE: Keep in sync with configs/tenantConstants.ts
 * (build config cannot import from vega-core due to circular dependencies)
 */
export enum Tenant {
  APOLLO = "apollo",
  ARES = "ares",
  CARLYLE = "carlyle",
  CELESTIAL = "celestial",
  FRANKLIN = "franklin",
  IK_PARTNERS = "ik-partners",
  MOTIVE = "motive",
}

export type TenantValue = `${Tenant}`;

export const DEFAULT_TENANT = Tenant.APOLLO;

export const VALID_TENANTS = Object.values(Tenant);

export function isValidTenant(value: unknown): value is TenantValue {
  return typeof value === "string" && VALID_TENANTS.includes(value as Tenant);
}
